import { ClipboardPulseIcon } from './ClipboardPulseIcon';

/**
 * author: Simran
 * id 8E3D93CC-DE0A-4828-AC9A-9A6CFD932978
 * name clipboard-pulse
 * version: 2.1.99
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/clipboard-pulse.svg
 * tags
 * - Medical / Hospital 
 */
export const ClipboardVitalsIcon = ClipboardPulseIcon;
export default ClipboardVitalsIcon